export default {
  bodyContentColor: Styles.color.grey.one,
};
